export default __webpack_public_path__ + "static/media/mendedhearts-03.e36544e2.png";